import { houseSearchType } from '@lib/config'

/**
 * type = 房源类型
 * ts = useTranslations('search')
 */
export function getSortOptions(type, ts) {
  const tmp = [{ label: ts('defaultSort'), value: '' }]
  const isSoldOrEstimate = [
    houseSearchType.estimate,
    houseSearchType.sold,
  ].indexOf(type) > -1

  if(isSoldOrEstimate) {
    tmp.push(
      { label: ts('valuePriceDescend'), value: '1' },
      { label: ts('valuePriceAscend'), value: '2' },
    )
  } else {
    tmp.push(
      { label: ts('listingTime'), value: '0' },
      { label: ts('priceDescend'), value: '1' },
      { label: ts('priceAscend'), value: '2' },
    )
  }
  
  // 人气高到低
  if([
    houseSearchType.residential,
    houseSearchType.rental,
  ].indexOf(type) > -1) {
    tmp.push({ label: ts('popularityAscend'), value: '13' })
  }

  if(houseSearchType.residential === type) {
    tmp.push({ label: ts('openhomeDate'), value: '8' })
    tmp.push({ label: ts('auctionDate'), value: '14' })
  }
  
  return tmp
}
